import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import events from '@guuru/events-web';

const ChatLayout = function () {
  useEffect(() => {
    events.chatLoaded();
  }, []);

  return <Outlet />;
};

export default ChatLayout;
